module.exports = __webpack_public_path__ + "img/opciones.e2b3a540.svg";